import { render, staticRenderFns } from "./ModuleCreateEdit.vue?vue&type=template&id=d8c9b642"
import script from "./ModuleCreateEdit.vue?vue&type=script&lang=js"
export * from "./ModuleCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./ModuleCreateEdit.vue?vue&type=style&index=0&id=d8c9b642&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports